import React, { useState, useEffect } from "react";
import "./ProgressBar.scss";

const ProgressBar = (props: any) => {
  const [width, setWidth] = useState(0);
  const [color, setColor] = useState("");
  const [position, setPosition] = useState("");
  useEffect(() => {
    setWidth(props.percentage);
    setColor(props.color);
    setPosition(props.position);
  }, [props]);
  // setWidth(props.percentage)
  // console.log("width is: ", width)
  // console.log("color ", color)
  const ProgressBarStylestart = {
    width: `${width}%`,
    background: `${color}`,
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
  };
  const ProgressBarStyleend = {
    width: `${width}%`,
    background: `${color}`,
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
  };
  const ProgressBarStylemid = {
    width: `${width}%`,
    background: `${color}`,
  };
  const ProgressBarStylefull = {
    width: `${width}%`,
    background: `${color}`,
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
  };
  return (
    <>
      {position === "start" ? (
        <div className="pw-barprogress" style={ProgressBarStylestart}></div>
      ) : position === "end" ? (
        <div className="pw-barprogress" style={ProgressBarStyleend}></div>
      ) : position === "full" ? (
        <div className="pw-progress-bar-container">
          <div className="pw-barprogress" style={ProgressBarStylefull}></div>
        </div>
      ) : (
        <div className="pw-barprogress" style={ProgressBarStylemid}></div>
      )}
    </>
  );
};

export default ProgressBar;
